module.exports = __webpack_public_path__ + "img/fabric-factory-view.jpg";